import moment from "moment";
import DateFormatting from "../../utilities/DateFormat";

export interface IInstrumentTypeListViewData {
  id: string;
  name: string;
  description: string;
  instrumentDetails?: any[];
  createdOn?: string;
  formatedDate?: any;
  instrumentDetailsName?: string;
}

export class InstrumentTypeListViewData implements IInstrumentTypeListViewData {
  id: string;
  name: string;
  description: string;
  instrumentDetails: any[];
  createdOn: string;
  formatedDate?: any;
  instrumentDetailsName?: string = "";
  constructor(
    id: string,
    name: string,
    description: string,
    instrumentDetails: any,
    createdOn: string
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.instrumentDetails = instrumentDetails;
    this.createdOn = createdOn
      ? moment(createdOn)
          .utcOffset(DateFormatting.getDateTimeRegionOffset())
          .format(DateFormatting.getDateTimeRegion())
      : createdOn;
    this.formatedDate = createdOn
      ? moment(createdOn)
          .utcOffset(DateFormatting.getDateTimeRegionOffset())
          .format(DateFormatting.getDateTimeRegion())
      : createdOn;

    const d: string[] = [];
    this.instrumentDetails?.forEach((t: any) => {
      d.push(t.name);
    });
    this.instrumentDetailsName = d.toString();
  }
}
